import ApiService from "../../ApiService";
import AppConfig from "../../../config/AppConfig";

const MyWalletService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/loadscreenview", {}, successCallback, failureCallback);
    },
    loadFundsDetails: (successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/loadfundsdetails", {}, successCallback, failureCallback);
    },
    loadUserFundByDate: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/loadfundsdetailsbydate", vo, successCallback, failureCallback);
    },
    loadWithdrawView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/loadwithdrawview", {}, successCallback, failureCallback);
    },
    verifyCode: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/verification", vo, successCallback, failureCallback);
    },
    sendVerifyCode: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/sendsmscode", vo, successCallback, failureCallback);
    },
    saveWithdrawal: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/savewithdrawal", vo, successCallback, failureCallback);
    },
    loadBankAccountsView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/loadbankaccountsview", {}, successCallback, failureCallback);
    },
    loadBankAccountView: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/loadbankaccountview", vo, successCallback, failureCallback);
    },
    deleteBankAccount: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/deletebankaccount", vo, successCallback, failureCallback);
    },
    saveBankAccount: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/savebankaccount", vo, successCallback, failureCallback);
    },
    executeFundTransaction: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/me/mywallet/executefundtransaction", vo, successCallback, failureCallback);
    },
};

export default MyWalletService;
